 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"DeliverOrders":"DeliverOrders","Home":"Home","ItemPage":"ItemPage","Noaccess":"Noaccess","ReservedPerBuyer":"ReservedPerBuyer","ResultsPerSalesman":"ResultsPerSalesman","StockPerBuyer":"StockPerBuyer","Werknemers":"Werknemers","about":"about","binnengekomen":"binnengekomen","CustomerPage":"CustomerPage","SalesPerWeek":"SalesPerWeek","gekochtvandaag":"gekochtvandaag","nieuwewerknemer":"nieuwewerknemer","profile":"profile","trustpilot":"trustpilot"}[chunkId]||chunkId) + "." + {"DeliverOrders":"901a01c2","Home":"05b44e35","ItemPage":"ef944918","Noaccess":"f6ee4962","ReservedPerBuyer":"080a5b24","ResultsPerSalesman":"a4675369","StockPerBuyer":"25c3fda9","Werknemers":"44356e96","about":"4b78fa4d","binnengekomen":"ea83ca1b","chunk-095e5c10":"a00e3ba3","chunk-1720d39b":"de4517a4","chunk-19a8a219":"4a304036","chunk-1abc0e14":"71b4d24f","chunk-223b6a50":"25bcf8d1","chunk-23f8ca48":"8cbb81ef","chunk-2581edf2":"dd3a7cb8","chunk-264e4bb5":"d07e2fb9","chunk-269277eb":"38e100a3","chunk-2ab66978":"917437ce","chunk-2d0a47fd":"dc8bd0f1","chunk-2d0af29b":"aa07957b","chunk-2d0b3289":"ebd5772a","chunk-2d0b59e8":"7b2014a9","chunk-2d0ba47e":"dab6c171","chunk-2d0bd58b":"48d2f347","chunk-2d0c0853":"4b3b30b0","chunk-2d0c2632":"68216eb6","chunk-2d0e93a1":"deb2e582","chunk-2d0efd37":"4a5128fd","chunk-2d208127":"bd6f2d40","chunk-2d208523":"2c5dc54c","chunk-2d212fb8":"6772db9f","chunk-2d21e1f9":"f3a3aea9","chunk-2d21f45c":"633ffb14","chunk-2d225039":"c07ac45b","chunk-2d226558":"de484c95","chunk-2f2b6f89":"73833374","chunk-34294a1e":"97b151fd","chunk-2d0da336":"d615e20f","chunk-34852946":"ee9f4b24","chunk-37524127":"ac2e08ff","chunk-3b2dc2e0":"2e2dca80","chunk-3b713b32":"5090d3c7","chunk-3ea901dc":"8a70c0db","chunk-3f0474ec":"0aa2084c","chunk-41bab363":"6d092f91","chunk-50f51e64":"406e68d9","chunk-5108e26c":"59f1d985","chunk-5109d88a":"21ce577d","chunk-59f4bc62":"f5feefe4","chunk-5f290120":"ab858b27","chunk-62e16f6c":"22930823","chunk-6493a3ae":"58b72bd0","chunk-664155a2":"ebc64f28","chunk-69f96591":"c16f4369","chunk-6e83591c":"22ec3898","chunk-2d0b2ed7":"bd8328cc","CustomerPage":"1842f8e2","SalesPerWeek":"e88db122","chunk-307a6411":"4393ec0e","chunk-c374ff7e":"6c5410fc","chunk-3854145e":"32f20525","chunk-387e2ef7":"6055e52a","chunk-3b722c5a":"4e73f940","chunk-3b9d43d2":"0459889f","chunk-3bcfb8c9":"c4a7040b","chunk-42525808":"31b84afe","chunk-45752ad3":"7eb3ff58","chunk-4ed5959a":"5e05bc6f","chunk-6acca1fc":"b61aab0a","chunk-6ecbf149":"dedf7935","chunk-9e77c868":"7caafd00","chunk-b38ff9d8":"241d1ddc","chunk-b8f8de9a":"7a90d2b1","chunk-c376e060":"6b16e039","chunk-cee81b9a":"bd989966","chunk-d910dbea":"78a1f4cb","chunk-df002f4c":"a669c3ab","chunk-b5cf0c72":"af091623","chunk-7dc6ceb0":"c8874585","chunk-821ecba8":"fe169756","chunk-84a7a1b8":"2d9026fd","chunk-8b1e007c":"1a83c765","chunk-974dfc2e":"603d4bac","chunk-99467b18":"e07e4592","chunk-b77091e2":"069ef4f2","chunk-b771d856":"d6488f0e","chunk-b772aa52":"42623589","chunk-b772c554":"fa5b4d37","chunk-b799db72":"5a6c3931","chunk-b79c04ee":"da75d284","chunk-b79d82fa":"c95dc11c","chunk-b7a0449e":"e6528163","chunk-b8f4c01c":"8f6c1ddc","chunk-b8f8477a":"644d6963","chunk-b8fac1e0":"9e71d3a4","chunk-b91dbeea":"eebe5fb3","chunk-b91fdd0c":"0c9f8cf2","chunk-b9222dec":"5aed8786","chunk-b9223614":"137a0cc7","chunk-b9237332":"3c7c28bb","chunk-b92747d2":"9d4495ef","chunk-babf8ba0":"2127607f","chunk-c2e85b3e":"271f62a2","chunk-c39abde0":"5a91d325","chunk-c39ccf5c":"1a9d801b","chunk-c39f31c6":"58e022b9","chunk-cd298e32":"bf90518a","chunk-dc7df5f6":"1c6a6804","chunk-e9129ef0":"10988746","chunk-e915d14a":"dd912511","gekochtvandaag":"ad8a836d","nieuwewerknemer":"b0206ac6","profile":"92af0d15","trustpilot":"44c46a5f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Home":1,"ItemPage":1,"chunk-1720d39b":1,"chunk-2581edf2":1,"chunk-264e4bb5":1,"chunk-2ab66978":1,"chunk-3ea901dc":1,"chunk-3f0474ec":1,"CustomerPage":1,"chunk-387e2ef7":1,"chunk-b5cf0c72":1,"chunk-821ecba8":1,"chunk-84a7a1b8":1,"chunk-babf8ba0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"DeliverOrders":"DeliverOrders","Home":"Home","ItemPage":"ItemPage","Noaccess":"Noaccess","ReservedPerBuyer":"ReservedPerBuyer","ResultsPerSalesman":"ResultsPerSalesman","StockPerBuyer":"StockPerBuyer","Werknemers":"Werknemers","about":"about","binnengekomen":"binnengekomen","CustomerPage":"CustomerPage","SalesPerWeek":"SalesPerWeek","gekochtvandaag":"gekochtvandaag","nieuwewerknemer":"nieuwewerknemer","profile":"profile","trustpilot":"trustpilot"}[chunkId]||chunkId) + "." + {"DeliverOrders":"31d6cfe0","Home":"07f81e68","ItemPage":"08d4f87b","Noaccess":"31d6cfe0","ReservedPerBuyer":"31d6cfe0","ResultsPerSalesman":"31d6cfe0","StockPerBuyer":"31d6cfe0","Werknemers":"31d6cfe0","about":"31d6cfe0","binnengekomen":"31d6cfe0","chunk-095e5c10":"31d6cfe0","chunk-1720d39b":"4b5af9db","chunk-19a8a219":"31d6cfe0","chunk-1abc0e14":"31d6cfe0","chunk-223b6a50":"31d6cfe0","chunk-23f8ca48":"31d6cfe0","chunk-2581edf2":"9e3734bf","chunk-264e4bb5":"da90f492","chunk-269277eb":"31d6cfe0","chunk-2ab66978":"9e3734bf","chunk-2d0a47fd":"31d6cfe0","chunk-2d0af29b":"31d6cfe0","chunk-2d0b3289":"31d6cfe0","chunk-2d0b59e8":"31d6cfe0","chunk-2d0ba47e":"31d6cfe0","chunk-2d0bd58b":"31d6cfe0","chunk-2d0c0853":"31d6cfe0","chunk-2d0c2632":"31d6cfe0","chunk-2d0e93a1":"31d6cfe0","chunk-2d0efd37":"31d6cfe0","chunk-2d208127":"31d6cfe0","chunk-2d208523":"31d6cfe0","chunk-2d212fb8":"31d6cfe0","chunk-2d21e1f9":"31d6cfe0","chunk-2d21f45c":"31d6cfe0","chunk-2d225039":"31d6cfe0","chunk-2d226558":"31d6cfe0","chunk-2f2b6f89":"31d6cfe0","chunk-34294a1e":"31d6cfe0","chunk-2d0da336":"31d6cfe0","chunk-34852946":"31d6cfe0","chunk-37524127":"31d6cfe0","chunk-3b2dc2e0":"31d6cfe0","chunk-3b713b32":"31d6cfe0","chunk-3ea901dc":"2608e4ab","chunk-3f0474ec":"02312892","chunk-41bab363":"31d6cfe0","chunk-50f51e64":"31d6cfe0","chunk-5108e26c":"31d6cfe0","chunk-5109d88a":"31d6cfe0","chunk-59f4bc62":"31d6cfe0","chunk-5f290120":"31d6cfe0","chunk-62e16f6c":"31d6cfe0","chunk-6493a3ae":"31d6cfe0","chunk-664155a2":"31d6cfe0","chunk-69f96591":"31d6cfe0","chunk-6e83591c":"31d6cfe0","chunk-2d0b2ed7":"31d6cfe0","CustomerPage":"3bb284e4","SalesPerWeek":"31d6cfe0","chunk-307a6411":"31d6cfe0","chunk-c374ff7e":"31d6cfe0","chunk-3854145e":"31d6cfe0","chunk-387e2ef7":"c2ebf225","chunk-3b722c5a":"31d6cfe0","chunk-3b9d43d2":"31d6cfe0","chunk-3bcfb8c9":"31d6cfe0","chunk-42525808":"31d6cfe0","chunk-45752ad3":"31d6cfe0","chunk-4ed5959a":"31d6cfe0","chunk-6acca1fc":"31d6cfe0","chunk-6ecbf149":"31d6cfe0","chunk-9e77c868":"31d6cfe0","chunk-b38ff9d8":"31d6cfe0","chunk-b8f8de9a":"31d6cfe0","chunk-c376e060":"31d6cfe0","chunk-cee81b9a":"31d6cfe0","chunk-d910dbea":"31d6cfe0","chunk-df002f4c":"31d6cfe0","chunk-b5cf0c72":"485ed9f3","chunk-7dc6ceb0":"31d6cfe0","chunk-821ecba8":"9e3734bf","chunk-84a7a1b8":"08d4f87b","chunk-8b1e007c":"31d6cfe0","chunk-974dfc2e":"31d6cfe0","chunk-99467b18":"31d6cfe0","chunk-b77091e2":"31d6cfe0","chunk-b771d856":"31d6cfe0","chunk-b772aa52":"31d6cfe0","chunk-b772c554":"31d6cfe0","chunk-b799db72":"31d6cfe0","chunk-b79c04ee":"31d6cfe0","chunk-b79d82fa":"31d6cfe0","chunk-b7a0449e":"31d6cfe0","chunk-b8f4c01c":"31d6cfe0","chunk-b8f8477a":"31d6cfe0","chunk-b8fac1e0":"31d6cfe0","chunk-b91dbeea":"31d6cfe0","chunk-b91fdd0c":"31d6cfe0","chunk-b9222dec":"31d6cfe0","chunk-b9223614":"31d6cfe0","chunk-b9237332":"31d6cfe0","chunk-b92747d2":"31d6cfe0","chunk-babf8ba0":"08d4f87b","chunk-c2e85b3e":"31d6cfe0","chunk-c39abde0":"31d6cfe0","chunk-c39ccf5c":"31d6cfe0","chunk-c39f31c6":"31d6cfe0","chunk-cd298e32":"31d6cfe0","chunk-dc7df5f6":"31d6cfe0","chunk-e9129ef0":"31d6cfe0","chunk-e915d14a":"31d6cfe0","gekochtvandaag":"31d6cfe0","nieuwewerknemer":"31d6cfe0","profile":"31d6cfe0","trustpilot":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
